import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const MOTSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="MOT-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="20"
        height="17"
        viewBox="0 0 20 17"
        data-testid="MOT-svg"
      >
        <defs>
          <path
            id="MOT"
            d="M38.46 187L34 194.585 29.54 187 24 196.42h8.947L28.489 204h11.08l-4.459-7.58H44L38.46 187zm.029 3.734l2.272 3.846h-4.545l2.273-3.846zm-8.92 0l2.272 3.846h-4.546l2.273-3.846zm4.488 7.58l2.273 3.847h-4.546l2.273-3.846z"
          />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(-24 -187)">
          <use fill="#0B0B0B" xlinkHref="#MOT" />
          <use fill="#070B16" xlinkHref="#MOT" />
        </g>
      </svg>
    </StyledContainer>
  );
};

export default MOTSVG;
